import React, { useState } from 'react';
import './Projects.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Projects = () => {
  const [filter, setFilter] = useState('All');
  const projects = [
    {
      title: "Connecto",
      image: "./Connecto Logo.png",
      description: "Empowering Creators And Brands To Navigate The Influencer Marketing Landscape",
      link: "https://connecto.co.ke/",
      color: "connecto-color",
      type: "Full-stack website"
    },
    {
      title: "Pro Resume Crafters",
      image: "./Pro.png",
      description: "Expert Resume Writing Services to Help You Land Your Dream Job",
      link: "https://proelite.vercel.app/",
      color: "pro-crafters-color",
      type: "Static website"
    },
    {
      title: "Kelvin Portfolio",
      image: "./portfolio.PNG",
      description: "By day, I sling code and wrestle with algorithms to create digital wonders",
      link: "https://kelvin-portfolio-eight.vercel.app/",
      color: "kelvin-portfolio-color",
      type: "Portfolio"
    },
    {
      title: "Ian Portfolio",
      image: "./ian.jpeg",
      description: "You imagine it, I create it",
      link: "https://ian-gichachi-portfolio.vercel.app/",
      color: "ian-portfolio-color",
      type: "Portfolio"
    },
    {
      title: "Kelvin CV",
      image: "./cv.png",
      description: "Versatile Full Stack Developer with a flair for creating elegant solutions in the least amount of time.",
      link: "https://mue-cv.tiiny.site/",
      color: "kelvin-cv-color",
      type: "Online CV"
    },
    {
      title: "Alex CV",
      image: "./Alex.png",
      description: "Dynamic and results-oriented professional.",
      link: "https://alec-cv.vercel.app/",
      color: "alex-cv-color",
      type: "Online CV"
    },
    {
      title: "Cappy Portfolio",
      image: "./Cappy.png",
      description: "The imaginative maestro behind the curtain of visual storytelling.",
      link: "https://cappy-portfolio.vercel.app/",
      color: "cappy-portfolio-color",
      type: "Portfolio"
    },
  ];

  const serviceTypes = ['All', 'Full-stack website', 'Static website', 'Online CV', 'Portfolio'];

  const filteredProjects = filter === 'All' ? projects : projects.filter(project => project.type === filter);

  return (
    <div className="portfolio">
      <h2 className="text-center display-4 fw-bold my-5">Our Projects</h2>

      <div className="filter-buttons text-center">
        {serviceTypes.map((type, index) => (
          <button 
            key={index} 
            onClick={() => setFilter(type)} 
            className={`btn ${filter === type ? 'active' : ''}`}
          >
            {type}
          </button>
        ))}
      </div>

      <div className="projects-container">
        {filteredProjects.map((project, index) => (
          <div className="projects-card" key={index}>
            <div className={`projects ${project.color}`}>
              <div className="projects-title">
                <h3>{project.title}</h3>
              </div>
              <div className="projects-image">
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  <img src={project.image} alt={project.title} />
                </a>
              </div>
              <div className="projects-description">
                <p>{project.description}</p>
              </div>
              <div className="projects-link">
                <a href={project.link} target="_blank" rel="noopener noreferrer">Visit Project</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;